import { render, staticRenderFns } from "./DgPagination.vue?vue&type=template&id=371db8ae&scoped=true&"
import script from "./DgPagination.vue?vue&type=script&lang=js&"
export * from "./DgPagination.vue?vue&type=script&lang=js&"
import style0 from "./DgPagination.vue?vue&type=style&index=0&id=371db8ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371db8ae",
  null
  
)

export default component.exports